import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { PnycButtonComponent } from '@ui-kit/pnyc-button/pnyc-button.component';
import { ScrollService } from './scroll.service';

@Component({
    selector: 'scroll-to-top',
    templateUrl: './scroll-to-top.component.html',
    styleUrls: ['./scroll-to-top.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PnycButtonComponent]
})
export class ScrollToTopComponent {
    private readonly scrollService = inject(ScrollService);

    readonly scrollToTopVisible = computed(() =>
        this.scrollService.scrollToTopVisible() && !this.scrollService.scrollToTopHidden());

    onScrollToTop(): void {
        this.scrollService.scrollToTop();
    }
}